import React, { useState } from 'react';
import moment from 'moment';
import { useIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Card, CardContent, WithStyles } from '@material-ui/core';

import { ILumaBotFlow } from 'ui-model';

import Tooltip from '../Tooltip';

import { DialogDelete, KebabActionsMenu, DialogFlowSessionLog } from './components';
import messages from './CardLumaBotFlow.messages';
import styles from './CardLumaBotFlow.styles';

interface ICardLumaBotFlow extends WithStyles<typeof styles> {
  patientId: string;
  cardId: string;
  data: ILumaBotFlow;
}

const CardLumaBotFlow: React.FC<ICardLumaBotFlow> = ({ classes, data, patientId, cardId }) => {
  const { _id: flowId, completedAt, status } = data;
  const { formatMessage } = useIntl();
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [isFlowSessionDialogOpen, setFlowSessionDialogOpen] = useState(false);

  const title = formatMessage(messages.title);

  return (
    <Card className={classes.root} color="default" elevation={1}>
      <CardContent className={classes.cardWrapper}>
        <Tooltip title={formatMessage(messages.tooltip)}>
          <Typography className={classes.title} variant="body1" onClick={() => setFlowSessionDialogOpen(true)}>
            {title}
          </Typography>
        </Tooltip>
        {status === 'completed' && (
          <div className={classes.descriptionWrapper}>
            <Typography className={classes.description} variant="body1">
              {formatMessage(messages.completedOn, { completedTimestamp: moment(completedAt).format('lll') })}
            </Typography>
          </div>
        )}
        <KebabActionsMenu
          patientId={patientId}
          flowId={flowId}
          cardId={cardId}
          status={status!}
          setDeleteDialogOpen={setDeleteDialogOpen}
          setFlowSessionDialogOpen={setFlowSessionDialogOpen}
        />
      </CardContent>
      <DialogDelete setDialogOpen={setDeleteDialogOpen} open={isDeleteDialogOpen} flowId={flowId} />
      <DialogFlowSessionLog setDialogOpen={setFlowSessionDialogOpen} open={isFlowSessionDialogOpen} flowId={flowId} />
    </Card>
  );
};

export default withStyles(styles)(CardLumaBotFlow);
